import React from 'react';
import Icon from '../../../components/AppIcon';
import {
  getSectionType,
  resolveBackgroundStyle,
} from '../utils/defaults';
import { resolveSectionBackgroundOverlayStyle } from '../utils/sectionOverlay';

function SectionUnderlay({ section }) {
  const bg = section?.background || {};
  const sectionType = getSectionType(section);
  const underFill =
    sectionType === 'normal'
      ? bg
      : {
          type: 'color',
          fill: bg.fill ?? bg.color ?? section.backgroundColor ?? '#ffffff',
          color: bg.color ?? section.backgroundColor ?? '#ffffff',
        };

  return (
    <div
      className="absolute inset-0 pointer-events-none"
      style={resolveBackgroundStyle(underFill, section?.backgroundColor || '#ffffff')}
      aria-hidden
    />
  );
}

export default function SectionBackground({ section, editor = false }) {
  const sectionType = getSectionType(section);
  const bg = section?.background || {};

  if (sectionType === 'video') {
    return (
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <SectionUnderlay section={section} />
        {bg.videoUrl ? (
          <video
            className="absolute inset-0 h-full w-full object-fill object-center"
            src={bg.videoUrl}
            poster={bg.posterUrl || undefined}
            autoPlay
            muted={bg.muted !== false}
            loop={bg.loop !== false}
            playsInline
          />
        ) : (
          <div
            className={`absolute inset-0 flex flex-col items-center justify-center gap-2 ${
              editor ? 'bg-muted/25' : 'bg-muted/10'
            }`}
          >
            <Icon name="Video" size={editor ? 28 : 0} className="text-muted-foreground/50" />
            {editor ? (
              <span className="text-[11px] text-muted-foreground">Vidéo de fond</span>
            ) : null}
          </div>
        )}
        {resolveSectionBackgroundOverlayStyle(section) ? (
          <div
            className="absolute inset-0 z-[1]"
            style={resolveSectionBackgroundOverlayStyle(section)}
          />
        ) : null}
      </div>
    );
  }

  if (sectionType === 'image') {
    const overlayStyle = resolveSectionBackgroundOverlayStyle(section);
    const objectPosition = bg.imagePosition || 'center';
    return (
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <SectionUnderlay section={section} />
        {bg.imageUrl ? (
          <img
            src={bg.imageUrl}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
            style={{ objectPosition }}
            draggable={false}
          />
        ) : (
          <div
            className={`absolute inset-0 flex flex-col items-center justify-center gap-2 ${
              editor ? 'bg-muted/25' : 'bg-muted/10'
            }`}
          >
            <Icon name="Image" size={editor ? 28 : 0} className="text-muted-foreground/50" />
            {editor ? (
              <span className="text-[11px] text-muted-foreground">Image de fond</span>
            ) : null}
          </div>
        )}
        {overlayStyle ? (
          <div className="absolute inset-0 z-[1]" style={overlayStyle} />
        ) : null}
      </div>
    );
  }

  return <SectionUnderlay section={section} />;
}
